import _extends from "@babel/runtime/helpers/extends";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _excluded = ["renderAs", "children", "clientId", "variant"],
  _excluded2 = ["component", "theme"];
var _templateObject;
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import styled from "@emotion/styled";
import { LodestarCoreTheme } from "@smartsheet/sds-theme-internal";
import { forwardRef, useContext, useMemo } from "react";
import { typeRampDefinitions } from "../constants/deprecatedTypeRampConstants";

/**
 * @deprecated please use the TypeRampV2 components instead.
 */

var ComponentBase = styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));

/**
 * @deprecated please use the TypeRampV2 components instead.
 */
export var TypeRamp = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var renderAs = _ref.renderAs,
    children = _ref.children,
    clientId = _ref.clientId,
    variant = _ref.variant,
    rest = _objectWithoutProperties(_ref, _excluded);
  var themeMode = useContext(LodestarCoreTheme);
  var _typeRampDefinitions$ = typeRampDefinitions[variant],
    component = _typeRampDefinitions$.component,
    theme = _typeRampDefinitions$.theme,
    restStyles = _objectWithoutProperties(_typeRampDefinitions$, _excluded2);
  // We need to perform this little remapping for a couple reasons:
  // 1. The TypeRamp component only supports lodestar-light (light) and oldestar right now.
  // 2. The typeRampDefinitions are part of the public API and cannot be changed to use the
  //    more centralized functions from src/util/theme.
  var fallbackThemeMode = function () {
    switch (themeMode) {
      case "light":
      case "dark":
      case "ursa-light":
      case "lodestar-light":
        return "light";
      case "oldestar":
        return "oldestar";
    }
  }();
  var styleObject = _objectSpread(_objectSpread({}, restStyles), theme[fallbackThemeMode]);
  var element = renderAs ? renderAs : component;

  // Memoizing this to ensure we won't create a new component each time.
  // withComponent returns a new component.
  // do we need the theme in here too??
  var ComponentRoot = useMemo(function () {
    return ComponentBase.withComponent(element);
  }, [element]);
  return jsx(ComponentRoot, _extends({
    ref: ref,
    "data-client-id": clientId,
    css: styleObject
  }, rest), children);
});
TypeRamp.displayName = "TypeRamp";
//# sourceMappingURL=TypeRamp.js.map